enum ApplicationReviewAnswerValue {
  Yes = 'Yes',
  No = 'No',
  Partial = 'Partial',
  None = 'None',
}
export default ApplicationReviewAnswerValue;
